<template>
  <header class="clm-header">
    <div class="clm-header__container clm-container">
      <div class="clm-header-logo">
        <a href="/" class="clm-header-logo__link">
          <img src="/local/img/header/logo.svg">
        </a>
      </div>
      <div class="clm-header-ctrl">
        <!--<clm-ctrl-lang :locale="locale" />-->
        <clm-ctrl-help :need-help="needHelp" />
      </div>
    </div>
  </header>
</template>

<script>
import clmCtrlLang from "../clm-ctrl-lang.vue";
import clmCtrlHelp from "../clm-ctrl-help.vue";
export default {
  name: "the-auth-header",
  components: {
    clmCtrlLang,
    clmCtrlHelp
  },
  inject: ['locale', 'needHelp'],
}
</script>
